import { useMemo } from 'react';
import { ObservationWrapper } from 'src/careflow/ph-core/fhir-client/fhir-base/wrappers/Observation';
import { useObservations } from 'src/careflow/ph-core/fhir-client/fhir-react';
import moment from 'moment';

type Props = {
  configurations: any;
  patientId?: string;
};

const useScores = ({ patientId, configurations}: Props) => {
  const [observations] = useObservations({
    filter: { patient: patientId },
    autofetch: !!patientId,
    map: ObservationWrapper,
  });

  const prs = useMemo(() => {
    if (observations) {
      try {
        return (
          observations
            ?.filter((x) => x?.isPrs(configurations?.preliminaryRiskScoreCode))
            ?.sort((a, b) => moment(b?.effectiveDateTime).diff(a?.effectiveDateTime))?.[0] ?? null
        );
      } catch (error) {
        return null;
      }
    }
  }, [observations, configurations]);

  const sil = useMemo(() => {
    if (observations) {
      try {
        return (
          observations
            ?.filter((x) => x?.isSil(configurations?.serviceIntegrationLevelCode))
            ?.sort((a, b) => moment(b?.effectiveDateTime).diff(a?.effectiveDateTime))?.[0] ?? null
        );
      } catch (error) {
        return null;
      }
    }
  }, [observations, configurations]);

  return {
    sil,
    prs,
  };
};

export default useScores;
